import React from "react";

import { MdmDeviceDto, useGetAllDevicesByProjectQuery, useGetProjectQuery } from "gql/generated/types";
import { Link, useNavigate, useParams } from "react-router-dom";
import { TableColumn } from "utils/types";
import DeviceStatus from "../components/DeviceStatus";
import ItemsTable from "../components/ItemsTable";

const Devices = () => {
  const { projectId } = useParams();
  const { data: deviceData, loading } = useGetAllDevicesByProjectQuery({
    variables: { id: projectId! },
    skip: !projectId,
  });
  const { data: projectData } = useGetProjectQuery({
    variables: { id: projectId! },
    skip: !projectId,
  });
  const navigate = useNavigate();

  const edit = (rowData: MdmDeviceDto) => (
    <Link to={`${rowData.id}`} title="Device Info">
      <i className="pi pi-external-link" />
    </Link>
  );

  const handleStatus = (rowData: MdmDeviceDto) => <DeviceStatus device={rowData} />

  const columns: TableColumn<MdmDeviceDto>[] = [
    { field: "identifier", header: "Identifier", sortable: true, filter: true },
    {
      field: "objectRelation.mdmObject.title",
      header: "Object Code",
      sortable: true,
      filter: true,
    },
    {
      field: "objectRelation.roleInObject",
      header: "Type",
      body: rowData =>
        projectData?.mdmProjectById.configuration?.deviceConfiguration.measurementTypes?.find(
          type => type?.id === rowData.objectRelation?.roleInObject
        )?.title ?? "",
      sortable: true,
    },
    { field: "config.title", header: "Config", sortable: true },
    {
      header: "Status",
      body: handleStatus,
      sortable: true,
      sortField: "boundDatasets.all.length",
      hideInFile: true,
    },
    {
      header: "Actions",
      body: edit,
      hideInFile: true,
      style: {
        width: "10%",
      },
    },
  ];
  return (
    <div className="card">
      <ItemsTable
        columns={columns}
        data={deviceData?.mdmDevicesByProjectId as MdmDeviceDto[] ?? []}
        searchFields={["identifier", "tags"]}
        isLoading={loading}
        tableName="Devices"
        onToolbarBtnClick={() => navigate("new")}
        toolbarBtnLabel="Add Device"
      />
    </div>
  );
};

export default Devices;